module.exports = __webpack_public_path__ + "static/media/wildlife.cc2b3745.svg";